import { Box, List, ListItem, ListItemText, Typography } from '@mui/material'
import React from 'react'
import { RedocStandalone } from 'redoc'
import { API_URL } from '../../app/const'

const ApiDocs = () => {
  return (<Box sx={{ textAlign: 'start' }}>
    <Typography variant='h3' gutterBottom sx={{ mt: 2 }}>API Documentation</Typography>
    <Typography variant='body1' gutterBottom>The Rentfinder API is organized around REST. Our API has predictable resource-oriented URLs, accepts JSON request bodies,
      returns JSON responses, and uses standard HTTP response codes, authentication, and verbs.
      {/* You can find the swagger for our API <a href="https://api.rentfinder.ai/swagger-ui/index.html">here</a> */}
    </Typography>
    <Typography variant='h4' gutterBottom sx={{ mt: 8 }}>Authentication</Typography>
    <Typography variant='body1' gutterBottom>Authentication is done by providing a valid API key in the header of the request. Eg: <i>Authorization: Bearer YOUR_JWT_TOKEN</i></Typography>
    <Typography variant='h4' gutterBottom sx={{ mt: 8 }}>Callbacks and payloads</Typography>
    <Typography variant='body1' gutterBottom>To ensure that your server only processes webhook deliveries that were sent by Rentfinder and to ensure that the delivery was not tampered with, you should validate the webhook signature before processing the delivery further. This will help you avoid spending server time to process deliveries that are not from Rentfinder and will help avoid man-in-the-middle attacks. <br />To do this, you need to:</Typography>
    <List>
      <ListItem>
        <ListItemText primary="Create a secret token" secondary="A random string of text with high entropy." />
      </ListItem>
      <ListItem>
        <ListItemText primary="Store the token securely on your server" secondary="Store it in a secure location that ONLY your server can access. Never hardcode a token into an application or push a token to any repository." />
      </ListItem>
      <ListItem>
        <ListItemText primary="Include the secret in the request payload" secondary="Include the secret in the request payload in callbackSharedSecret field." />
      </ListItem>
      <ListItem>
        <ListItemText primary="Validate incoming payloads against the token" secondary="This is to verify that the data is actually coming from Rentfinder and were not tampered with. GitHub will use your secret token to create a hash signature that's sent to you with each payload. The signature will appear in each delivery as the value of the X-Signature header. In your code that handles webhook deliveries, you should calculate a hash using your secret token. Then, compare the hash that GitHub sent with the expected hash that you calculated, and ensure that they match" />
      </ListItem>
    </List>
    <Typography variant='body1' gutterBottom>
      How to validate the hashes, <a href="https://docs.github.com/en/webhooks/using-webhooks/validating-webhook-deliveries#testing-the-webhook-payload-validation">examples</a>
    </Typography>
    <Typography variant='h2' gutterBottom sx={{ mt: 8 }}>API Endpoints</Typography>
    <RedocStandalone
      specUrl={`${API_URL}/v3/api-docs`}
      options={{
        theme: { colors: { primary: { main: '#423AA4B3' } } },
      }}
    />
  </Box>)
}

export default ApiDocs